'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parseLinks = require('parse-links');

var _parseLinks2 = _interopRequireDefault(_parseLinks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LegacyOffsetCollectionResponse = function () {
  /**
   * Wraps a legacy collection API Response with useful methods for dealing
   * with paging through the records.
   * @constructor
   * @param {Client} client
   * @param {Object} response - The response object from the API.
   */
  function LegacyOffsetCollectionResponse(client, response) {
    _classCallCheck(this, LegacyOffsetCollectionResponse);

    this.client = client;
    this.data = this._getData(response);
    this.status = response.status;
    this.headers = response.headers;
    this.config = response.config;
    this.links = this._getLinks(response);
    this.totalCount = this._getTotalCount(response);
  }

  _createClass(LegacyOffsetCollectionResponse, [{
    key: 'hasNext',
    value: function hasNext() {
      return this.links.next !== undefined;
    }
  }, {
    key: 'getNext',
    value: function getNext() {
      // eslint-disable-next-line no-unused-vars
      var _config = this.config,
          params = _config.params,
          options = _objectWithoutProperties(_config, ['params']);

      options.url = this.links.next;
      return this.client.request(options);
    }
  }, {
    key: '_getData',
    value: function _getData() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          data = _ref.data;

      if (data && data.length !== undefined) {
        return data;
      }
      return [];
    }
  }, {
    key: '_getLinks',
    value: function _getLinks() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          headers = _ref2.headers;

      var linkHeader = headers.link;
      if (!linkHeader) {
        return {};
      }
      return (0, _parseLinks2.default)(linkHeader);
    }
  }, {
    key: '_getTotalCount',
    value: function _getTotalCount() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          headers = _ref3.headers;

      var totalCount = headers['x-total-count'];
      if (totalCount !== undefined) {
        totalCount = parseInt(totalCount, 10);
      }
      return totalCount;
    }
  }]);

  return LegacyOffsetCollectionResponse;
}();

exports.default = LegacyOffsetCollectionResponse;